import React from 'react';
import { Check } from 'lucide-react';
export function LongFormCopy() {
  return <div className="max-w-3xl mx-auto py-24 px-4 sm:px-6 lg:px-8" data-id="element-45">
      <div className="prose prose-lg mx-auto text-ink/80 font-light leading-relaxed" data-id="element-46">
        <h2 className="text-4xl sm:text-5xl font-serif text-center text-ink mb-12 leading-tight" data-id="element-47">
          ¿Y si el verdadero problema nunca fue tu fuerza de voluntad?
        </h2>

        <p className="mb-6" data-id="element-48">
          Durante años nos hicieron creer que bajar de peso era simplemente una
          cuestión de comer menos y hacer más ejercicio.
        </p>

        <p className="mb-6" data-id="element-49">Y cuando eso no funcionaba...</p>

        <p className="mb-12" data-id="element-50">
          Nos decían que nos faltaba disciplina. Motivación. O fuerza de
          voluntad.
        </p>

        <div className="h-px w-24 bg-gold/40 mx-auto mb-12" data-id="element-51"></div>

        <p className="text-2xl font-serif text-ink text-center mb-12 leading-relaxed" data-id="element-52">
          Pero ¿y si el problema nunca hubiera sido tu esfuerzo?
        </p>

        <p className="mb-6" data-id="element-53">
          Hoy la ciencia sabe que el control del peso es mucho más complejo.
          Hormonas, metabolismo, señales de hambre, resistencia a la insulina,
          genética e inflamación participan diariamente en la forma en que tu
          cuerpo regula el peso.
        </p>

        <p className="mb-6" data-id="element-54">
          Por eso muchas personas sienten que luchan constantemente contra su
          propio cuerpo. No porque les falte voluntad... Sino porque nunca les
          enseñaron cómo funciona realmente.
        </p>

        <p className="mb-12" data-id="element-55">
          El problema es que, al buscar respuestas, encontramos miles de
          opiniones contradictorias. En redes sociales unos presentan los
          medicamentos GLP-1 como una solución milagrosa. Otros aseguran que son
          peligrosos.
        </p>

        <p className="font-serif text-center text-3xl text-ink mb-8" data-id="element-56">
          ¿A quién creer?
        </p>

        <p className="text-center text-xl text-gold font-serif italic mb-16" data-id="element-57">
          La respuesta debería ser siempre la misma: A la evidencia científica.
        </p>

        <div className="text-center my-20" data-id="element-58">
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-gold font-medium mb-6" data-id="element-59">
            Presentamos
          </span>
          <h3 className="text-4xl sm:text-5xl font-serif text-ink mb-6 leading-tight" data-id="element-60">
            Péptidos, GLP-1 y Pérdida de Peso
          </h3>
          <p className="text-lg text-ink/70 max-w-xl mx-auto font-light" data-id="element-61">
            La guía educativa que te ayudará a comprender cómo funciona
            realmente el manejo moderno del peso. Aquí no encontrarás promesas
            milagrosas. Encontrarás conocimiento.
          </p>
        </div>

        <div className="bg-white p-10 sm:p-14 border border-gold/20 shadow-sm my-20 text-center relative" data-id="element-62">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-ivory px-4" data-id="element-63">
            <span className="text-gold" data-id="element-64">✦</span>
          </div>
          <h3 className="text-3xl font-serif text-ink mb-6" data-id="element-65">
            Mucho más que un ebook...
          </h3>
          <p className="text-ink/70 mb-6 font-light" data-id="element-66">
            Es una herramienta para ayudarte a comprender mejor tu cuerpo,
            interpretar la información con criterio y conversar con mayor
            confianza con tu profesional de la salud.
          </p>
          <p className="text-emerald font-medium tracking-wide text-sm uppercase" data-id="element-67">
            Porque las mejores decisiones comienzan con una buena educación.
          </p>
        </div>

        <div className="bg-ivory-dark p-10 sm:p-14 border border-gold/10 my-20" data-id="element-68">
          <h3 className="text-2xl font-serif text-ink mb-10 text-center" data-id="element-69">
            Esta guía es ideal para ti si...
          </h3>
          <ul className="space-y-6" data-id="element-70">
            {['Has intentado perder peso varias veces sin obtener resultados duraderos.', 'Quieres entender cómo funcionan los tratamientos con GLP-1 antes de tomar una decisión.', 'Ya utilizas uno de estos tratamientos y deseas acompañarlo con mejores hábitos.', 'Buscas información clara, organizada y basada en evidencia científica.', 'Prefieres tomar decisiones con conocimiento, no con opiniones de internet.'].map((text, i) => <li key={i} className="flex items-start" data-id="element-71">
                <Check className="w-5 h-5 text-gold mt-1 mr-4 flex-shrink-0 stroke-[1.5]" data-id="element-72" />
                <span className="text-ink/80 font-light leading-relaxed" data-id="element-73">
                  {text}
                </span>
              </li>)}
          </ul>
        </div>

        <div className="bg-white border border-ink/10 p-8 my-16 text-center" data-id="element-74">
          <h4 className="text-xs tracking-[0.2em] uppercase text-ink mb-4 font-medium" data-id="element-75">
            Aviso importante
          </h4>
          <p className="text-sm text-ink/60 leading-relaxed font-light" data-id="element-76">
            Este material tiene fines exclusivamente educativos e informativos.
            No sustituye la consulta médica, el diagnóstico ni el tratamiento
            indicado por un profesional de la salud. Cualquier decisión
            relacionada con medicamentos o tratamientos debe tomarse junto con
            un médico calificado.
          </p>
        </div>
      </div>
    </div>;
}